import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatDividerModule } from '@angular/material/divider'
import { NgxMaskDirective } from 'ngx-mask'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { emailValidator } from '../../../shared/utils/email_validator'
import moment from 'moment/moment'
import { cpfValidator } from '../../../shared/utils/cpf_validator'
import { ContactClientCreateComponent } from '../../contact/contact-client-create/contact-client-create.component'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { DriverTypeService } from '../../../core/services/doctor/driver-type/driver-type.service'
import { CreateDriverModel } from '../../../core/models/driver.model'
import { ContactClientEditComponent } from '../../contact/contact-client-edit/contact-client-edit.component'
import {NgIf} from '@angular/common';
import {HealthUnitService} from '../../../core/services/health-unit/location/health-unit.service';
import {AdminService} from '../../../core/services/admin/admin.service';

@Component({
  selector: 'monitoring-details',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatOption,
    MatSelect,
    MatDividerModule,
    NgxMaskDirective,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSlideToggle,
    ContactClientEditComponent,
    NgIf,
  ],
  templateUrl: './monitoring-details.component.html',
  styleUrl: './monitoring.component.scss',
  providers: [
    ViaCepService,
    EmployeeStatusService,
    HabitsService,
    AddressTypeService,
  ],
  standalone: true,
})
export class MonitoringDetailsComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private viaCepService: ViaCepService,
    private employeeStatusService: EmployeeStatusService,
    private adminService: AdminService,
    private addressTypeService: AddressTypeService,
    private locationService: HealthUnitService,
    private specialtyService: DriverTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<MonitoringDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data.item
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const currentDay = today.getDate()
    this.maxDate = new Date(currentYear - 18, currentMonth, currentDay)
    this.minDate = today
  }

  item: any = {}

  @Output() responseEdit = new EventEmitter()
  @ViewChild('birth') datepickerBirth: MatDatepicker<any> | undefined
  @ViewChild('hiring') datepickerHiring: MatDatepicker<any> | undefined
  @ViewChild('validity') datepickerValidity: MatDatepicker<any> | undefined

  formEmployee: FormGroup = new FormGroup({
  })
  maxDate!: Date
  minDate!: Date

  loading: boolean = false
  listPessoas: any[] = []
  listUnidades: any[] = []
  tipoPessoa: number = 0
  listSpecialty: any[] = []
  listAddressType: any[] = []
  listStatusEmployee: any[] = []
  listTypeDriver: any[] = []
  listCategory: any[] = [
    { id: 'A', description: 'A' },
    { id: 'B', description: 'B' },
    { id: 'C', description: 'C' },
    { id: 'D', description: 'D' },
    { id: 'E', description: 'E' },
  ]

  contactList: any[] = []
  fileList: any[] = []
  // public TipoDocId: number = 0
  // public Descricao: string = ''
  // public Arquivo: File | null = null

  ngOnInit(): void {
    console.log("iniciou no local Correto!")
    this.createForm();
    this.listPessoasCreate();
    this.getUnidadesDeSaude();
    this.formEmployee.get('typePerson')?.valueChanges.subscribe(value => {
      this.tipoPessoa = value
    });
    this.fillForm(this.item)
  }
  listPessoasCreate(){
    this.listPessoas = [{id: 1, descricao: "Pessoa Física"},{id: 2, descricao: "Pessoa Jurídica"}]
  }
  close() {
    this.dialogRef.close()
  }

  getUnidadesDeSaude() {
    this.locationService.listActiveLocation().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listUnidades = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
        if (this.listSpecialty.length > 0) this.fillForm(this.item);
      },
    })
  }


  createModel() {
    const tipoPessoa = this.formEmployee.get('typePerson')?.value

    const comum = {
      // id: 2952,
      id: this.item.id,

      // sempre admin
      perfil_id: 1,

      id_tipo_pessoa: tipoPessoa,
      unidadeId: this.formEmployee.get('healthUnit')?.value,

      // usuario
      email: this.formEmployee.get('email')?.value,
      senha: this.formEmployee.get('password')?.value === '•••••••••' ? null : this.formEmployee.get('password')?.value,

      // pessoa / telefones / observacao
      telefone_1: this.formEmployee.get('phone')?.value,
      telefone_whatsapp:
        this.formEmployee.get('telefone_whatsapp')?.value ||
        this.formEmployee.get('phone')?.value,
      observacao: this.formEmployee.get('observacao')?.value || '',

      // endereco
      logradouro: this.formEmployee.get('street')?.value,
      numero: this.formEmployee.get('number')?.value,
      bairro: this.formEmployee.get('neighborhood')?.value,
      cidade: this.formEmployee.get('city')?.value,
      cep: this.formEmployee.get('postalCode')?.value,
      estado: (this.formEmployee.get('state')?.value || '').toUpperCase(),
    }

    if (tipoPessoa === 1) {
      // Pessoa Física
      return {
        ...comum,
        cpf: this.formEmployee.get('cpf')?.value,
        rg: this.formEmployee.get('rg')?.value,
        genero: this.formEmployee.get('sex')?.value,
        data_nascimento: this.formEmployee.get('birth')?.value
          ? moment(this.formEmployee.get('birth')?.value).format('YYYY-MM-DD')
          : null,
        nomeCompleto: this.formEmployee.get('name')?.value,
        estado_civil: this.formEmployee.get('maritalStatus')?.value,
      }
    }

    if (tipoPessoa === 2) {
      // Pessoa Jurídica
      return {
        ...comum,
        nome_fantasia: this.formEmployee.get('fantasy_name')?.value,
        razao_social: this.formEmployee.get('corporate_name')?.value,
        cnpj: this.formEmployee.get('cnpj')?.value,
      }
    }

    return { ...comum }
  }


  createForm(): void {
    this.formEmployee = this.formBuilder.group({
      // Comum
      healthUnit: [null, [Validators.required]],
      typePerson: [null, [Validators.required]],
      email: ['', [Validators.required, emailValidator()]],
      password: ['•••••••••', [Validators.required]],
      phone: ['', [Validators.required]],
      telefone_whatsapp: ['', []],
      observacao: ['', []],

      // Endereço
      street: ['', [Validators.required]],
      number: ['', [Validators.required]],
      neighborhood: ['', [Validators.required]],
      city: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      state: ['', [Validators.required]],

      // Pessoa Física
      name: ['', []],
      rg: ['', []],
      cpf: ['', []],
      sex: ['', []],
      birth: [null, []],
      maritalStatus: [null, []],

      // Pessoa Jurídica
      fantasy_name: ['', []],
      corporate_name: ['', []],
      cnpj: ['', []],
    })
  }

  fillForm(item: any) {
    console.log(item, 'item')
    this.tipoPessoa = item.id_tipo_pessoa;
    this.formEmployee.patchValue({

      email: item.email,
      phone: item.telefone_1,
      telefone_whatsapp: item.telefone_whatsapp,
      observacao: item.observacao,

      street: item.endereco.logradouro,
      number: item.endereco.numero,
      neighborhood: item.endereco.bairro,
      city: item.endereco.cidade,
      postalCode: item.endereco.cep,
      state: item.endereco.estado,
      healthUnit: item.id_unidade,
      typePerson: item.id_tipo_pessoa,
    })

    if (item.id_tipo_pessoa === 1) {
      // Pessoa Física
      this.formEmployee.patchValue({
        name: item.dados_pessoa.nomeCompleto,
        rg: item.dados_pessoa.rg,
        cpf: item.dados_pessoa.cpf,
        sex: item.dados_pessoa.genero,
        maritalStatus: Number(item.dados_pessoa.estado_civil),
        birth: item.dados_pessoa.data_nascimento
          ? moment(item.dados_pessoa.data_nascimento, 'YYYY-MM-DD').toDate()
          : null,
      })
    }

    if (item.id_tipo_pessoa === 2) {
      // Pessoa Jurídica
      this.formEmployee.patchValue({
        fantasy_name: item.dados_pessoa.nome_fantasia,
        corporate_name: item.dados_pessoa.razao_social,
        cnpj: item.dados_pessoa.cnpj,
      })

    }
    console.log('item.id_especialidade:', this.item?.id_especialidade, typeof this.item?.id_especialidade);
    console.log('listSpecialty[0].id:', this.listSpecialty?.[0]?.id, typeof this.listSpecialty?.[0]?.id);

  }
  fillFormViaCep(element: any) {
    if (element.erro) {
      this.formEmployee.get('street')?.setValue('')
      this.formEmployee.get('number')?.setValue('')
      this.formEmployee.get('neighborhood')?.setValue('')
      this.formEmployee.get('city')?.setValue('')
      this.formEmployee.get('state')?.setValue('')
    } else {
      this.formEmployee.get('street')?.setValue(element.logradouro)
      this.formEmployee.get('number')?.setValue('')
      this.formEmployee.get('neighborhood')?.setValue(element.bairro)
      this.formEmployee.get('city')?.setValue(element.localidade)
      this.formEmployee.get('state')?.setValue(element.estado)
    }
  }

  getAddressByPostalCode() {
    let postalCode = this.formEmployee.get('postalCode')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    }
  }

  getList(list: any[], type: 'contact' | 'file') {
    switch (type) {
      case 'contact':
        this.contactList = list
        break
      case 'file':
        this.fileList = list
        break
    }
  }

  editDriver() {
    this.loading = true
    this.adminService.editAdmin(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.loading = false
        this.snackbar.success(response.message)
        this.responseEdit.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        // this.formIndividual.reset()
        // this.formFinancial.reset()
      },
    })
  }

  openDatepicker(datePicker: 'hiring' | 'birth' | 'validity') {
    if (this.datepickerBirth && datePicker == 'birth') {
      this.datepickerBirth.open()
    }
    if (this.datepickerHiring && datePicker == 'hiring') {
      this.datepickerHiring.open()
    }
    if (this.datepickerValidity && datePicker == 'validity') {
      this.datepickerValidity.open()
    }
  }

  checkForm() {
    if (
      this.formEmployee.valid
      // this.formEmployee.valid &&
      // this.contactList.length >= 1 &&
      // this.fileList.length >= 1
    ) {
      return true
    } else {
      return false
    }
  }
}
